import { gql } from '@apollo/client';

export const GET_RETENTION_FILTER_OPTIONS = gql`
  query GetRetentionFilterOptions {
    getRetentionFilterOptions {
      countries
      orderTags
      collectionTitles
      vendors
      productTypes
    }
  }
`;

export const GET_RETENTION_ANALYTICS = gql`
  query GetRetentionAnalytics(
    $dateRange: DateRangeInput!
    $customerSegment: String
    $productId: String
    $narrowing: RetentionAnalyticsNarrowingInput
  ) {
    getRetentionAnalytics(
      dateRange: $dateRange
      customerSegment: $customerSegment
      productId: $productId
      narrowing: $narrowing
    ) {
      firstPurchaseRepeatObservationWindowDays
      summary {
        customersAnalyzed
        repeatPurchaseRate
        avgDaysToSecondPurchase
        medianDaysToSecondPurchase
        avgDaysToSameProductReorder
        inactivityWindowDays
        inactiveCustomersAfter60Days
        inactiveCustomersAfter90Days
        cumulativeLtv
        cumulativeGrossMarginLtv
        grossMarginCostCoverage
        topFirstPurchaseProduct {
          productId
          productTitle
          repeatRate
          productImageUrl
        }
        topLtvStarterProduct {
          productId
          productTitle
          ltv
          firstPurchaseCustomers
          productImageUrl
        }
        metaAdSpend
        googleAdSpend
        blendedAdSpend
        averageBlendedCac
        ltvToCacRatio
      }
      daysToSecondPurchaseDistribution {
        bucket
        customers
        percentage
      }
      firstPurchaseProductsGeneratingRepeats {
        productId
        productTitle
        productImageUrl
        firstPurchaseCustomers
        eligibleFirstPurchaseCustomers
        repeatCustomers
        repeatRate
        rawRepeatRate
        adjustedRepeatRate
        repeatImpactScore
        lowSample
        avgDaysToSecondPurchase
        topSecondPurchaseProductTitle
        topSecondPurchaseProductImageUrl
      }
      firstPurchaseProductsByFollowUpOrderVolume {
        productId
        productTitle
        productImageUrl
        firstPurchaseCustomers
        totalSubsequentOrders
        avgSubsequentOrdersPerFirstBuyer
        repeatCustomers
        lowSample
      }
      firstPurchaseProductsByLtv {
        productId
        productTitle
        productImageUrl
        firstPurchaseCustomers
        repeatCustomers
        totalRevenue
        totalGrossMargin
        ltv
        grossMarginLtv
        avgOrdersPerCustomer
        ltvImpactScore
        lowSample
      }
      mostCommonSecondPurchases {
        firstProductId
        firstProductTitle
        firstProductImageUrl
        secondProductId
        secondProductTitle
        secondProductImageUrl
        customers
        avgDelayDays
        repeatRate
      }
      purchaseDecayCurve {
        day
        repurchasedPercentage
        inactivePercentage
        eligibleCustomers
        repurchasedCustomers
        incrementalRepurchasedCustomers
        incrementalRepurchasedPercentage
      }
      cohortLtvCurve {
        day
        eligibleCustomers
        cumulativeLtv
        cumulativeGrossMarginLtv
        ordersPerCustomer
        ltvToCacRatio
      }
      customerEconomics {
        segment
        label
        customers
        avgOrders
        avgRevenue
        avgMargin
        ltv
      }
      insights {
        type
        severity
        title
        description
        recommendedAction
        primaryProductImageUrl
        secondaryProductImageUrl
        metricLabel
      }
      warnings {
        code
        message
      }
    }
  }
`;
